export default class GAHTMLElement {
    /**
     * Главный баннер для десктопа
     */
    private static normalBlocks: NodeList;

    /**
     * Товары на главной "Акция"
     */
    private static itemsAction: NodeList;

    /**
     * Горячее предложение
     */
    private static itemsHot: NodeList;

    /**
     * Хиты продаж
     */
    private static itemsHit: NodeList;

    /**
     * Рекомендации
     */
    private static itemsRec: NodeList;

    private static viewed: NodeList;

    /**
     * Товар дня подгружается через js - не могу пока поймать его
     * const itemsFavorite = document
     *     .querySelector('.FAVORIT_ITEM')
     *    .querySelectorAll('.item');
     */

    static getProductsInMainPage() {
        GAHTMLElement.itemsAction = document
            .querySelector('.new_custom_akc')
            .querySelectorAll('.item .catalog_item');
        GAHTMLElement.itemsHot = document
            .querySelector('.new_custom_hot')
            .querySelectorAll('.item .catalog_item');
        GAHTMLElement.itemsHit = document
            .querySelector('.new_custom_hit')
            .querySelectorAll('.item .catalog_item');
        GAHTMLElement.itemsRec = document
            .querySelector('.new_custom_rec')
            .querySelectorAll('.item .catalog_item');
        /** TODO ранее просмотренные не обработаны **/

        return new Set([
            ...GAHTMLElement.itemsAction,
            ...GAHTMLElement.itemsHot,
            ...GAHTMLElement.itemsHit,
            ...GAHTMLElement.itemsRec,
        ]);
    }

    static getPromosInMainPage() {
        GAHTMLElement.normalBlocks = document
            .querySelector('.top_big_one_banner')
            .querySelectorAll('.normal_block');

        return new Set([...GAHTMLElement.normalBlocks]);
    }
}
